export default "__VITE_ASSET__BCzvKW0y__"